import { Component, ViewChild } from '@angular/core'
import { Popover } from 'primeng/popover'
import { PopoverModule } from 'primeng/popover'
import { ButtonModule } from 'primeng/button'
import { TranslateModule } from '@ngx-translate/core'
import { UserInfosComponent } from './user-infos/user-infos.component'
import { AuthService } from '../../../services/auth.service'

@Component({
  selector: 'app-menubar-popover',
  imports: [PopoverModule, ButtonModule, TranslateModule, UserInfosComponent],
  templateUrl: './menubar-popover.component.html',
  styleUrl: './menubar-popover.component.scss',
})
export class MenubarPopoverComponent {
  isPopoverHidden: boolean = true
  constructor(private authService: AuthService) {}

  @ViewChild('op') op: Popover | null = null

  displayMenu(event: Event) {
    if (this.op) {
      if (this.isPopoverHidden) {
        this.op.show(event)
        if (this.op.container) {
          this.op.align()
        }
        this.isPopoverHidden = false
      } else {
        this.op.hide()
        this.isPopoverHidden = true
      }
    }
  }

  onLogout() {
    if (this.op) {
      this.op.hide()
      this.isPopoverHidden = true
    }
    this.authService.logout()
  }

  onHidePopover() {
    this.isPopoverHidden = true
  }
}
